import { Component, ElementRef, HostListener, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxFloatUiPlacements, NgxFloatUiTriggers, NgxFloatUiDirective, NgxFloatUiContentComponent } from 'ngx-float-ui';
import { IconSpriteModule } from 'ng-svg-icon-sprite';

import { IconButtonColorEnumPipe } from '../icon-button/icon-button-color-enum.pipe';

@Component({
    selector: 'app-popper-tool-tip',
    templateUrl: './popper-tool-tip.component.html',
    styleUrls: ['./popper-tool-tip.component.scss'],
    standalone: true,
    imports: [NgxFloatUiDirective, IconSpriteModule, NgxFloatUiContentComponent, IconButtonColorEnumPipe]
})
export class PopperToolTipComponent implements OnInit {
  @ViewChild('tooltipElement', { static: true }) tooltipElement!: ElementRef;
  @ViewChild('floatUiRef', { static: true }) floatUiRef!: NgxFloatUiDirective;
  title: string = "";
  @Input() iconColor: string="BLUE";
  @Input() heightInPx: string = "16px";
  @Input() widthInPx: string = "16px";
  @Input() screenReaderText: string = "";
  @Input() popperPlacementParam: NgxFloatUiPlacements | Function = NgxFloatUiPlacements.AUTO;
  @Input() isHtmlContent: boolean = false;
  popperPlacement: NgxFloatUiPlacements;
  popperTrigger: NgxFloatUiTriggers = this.deviceService.isDesktop() ? NgxFloatUiTriggers.hover : NgxFloatUiTriggers.click;

  constructor(private ngZone: NgZone, private deviceService: DeviceDetectorService) { }

  ngOnInit(): void {

    this.popperPlacement = this.popperPlacementParam instanceof Function ? this.popperPlacementParam() : this.popperPlacementParam;
  }

  @HostListener('document:keydown.escape')
  onEscapeKeydown(): void {
    this.floatUiRef?.hide();
  }

}
